import React from "react";
import { Button } from "../SignUpButton";
import { BalancedStepTitle } from "../BalancedStepTitle";
import { BalancedStepSubtitle } from "../BalancedStepSubtitle";

const UnsupportedStep: React.FC = () => {
  const handleRedirect = () => {
    window.location.href = "https://www.pushpress.com/thanks-for-your-interest";
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="Country does not support Stripe" />
        <BalancedStepSubtitle
          subtitle="Sorry, we don't currently support payment processing in your
          country."
        />
      </div>
      <div className="tw-flex tw-justify-between tw-items-center">
        <Button
          onClick={handleRedirect}
          size="fat"
          className="tw-uppercase tw-tracking-widest tw-w-full tw-flex tw-py-4 tw-items-center tw-gap-2 tw-text-white"
        >
          <span>Return to PushPress.com</span>
        </Button>
      </div>
    </>
  );
};

export default UnsupportedStep;
